import { Grid, Paper, TableCell, TableRow } from "@material-ui/core";
import { MasterButton } from "App/Component/ui";
import Modal from "App/Component/ui/Modal/Modal";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { formatRupiah } from "App/utils/helpers";
import { FreezeTableClient } from "components/organism";
import React from "react";

const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "barang_id",
    disablePadding: false,
    label: "ID BARANG",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "barang_nama",
    disablePadding: false,
    label: "NAMA BARANG",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "id_inventory",
    disablePadding: false,
    label: "ID INNVENTORY",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "qty",
    disablePadding: false,
    label: "QTY",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "hargapokok",
    disablePadding: false,
    label: "HARGA POKOK",
    align: "left",
    minWidth: "130px",
  },
  {
    id: "keterangan",
    disablePadding: false,
    label: "KETERANGAN",
    align: "left",
    minWidth: "200px",
  },
];

function ModalNotif({ setShowModal, dataNotif }) {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: dataNotif,
    orderByDefault: "barang_id",
    orderByRow: ["barang_id", "tipe", "gudang_id"],
  });
  return (
    <>
      <Modal title={"PERHATIAN !"} show={setShowModal} width="28%">
        <Paper className="p-1">
          <Grid container direction="row">
            <Grid item md={12}>
              <FreezeTableClient
                title=""
                setQ={setQ}
                maxHeight="300px"
                withAddButton={false}
                withExportButton={false}
                order={order}
                orderBy={orderBy}
                handleRequestSort={handleRequestSort}
                length={length}
                rows={dataNotif}
                headCells={headCells}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
              >
                {stableSort(data, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell width={"4%"} align="center">
                          {index + 1}
                        </TableCell>
                        <TableCell align="left">{row?.barang_id}</TableCell>
                        <TableCell align="left">-</TableCell>
                        <TableCell align="left">{row?.data?.id_inventory??"-"}</TableCell>
                        <TableCell align="left">{formatRupiah(row?.data?.qty)}</TableCell>
                        <TableCell align="left">{formatRupiah(row?.data?.hargapokok)}</TableCell>
                        <TableCell align="left">{row?.data?.message}</TableCell>
                      </TableRow>
                    );
                  })}
              </FreezeTableClient>
            </Grid>
          </Grid>
          <Grid
        container
        direction='row'
        justifyContent='flex-end'
        alignItems='center'>
        <MasterButton
          className={"mr-1 mt-1"}
          color={"green"}
          size='lg'
          onClick={(e) => {
            setShowModal();
          }}
          name={"Oke"}
        />
      </Grid>
        </Paper>
      </Modal>
    </>
  );
}

export default ModalNotif;
